module.exports = __webpack_public_path__ + "static/media/transilluminator-open-with-gel.16a07f01.svg";